import { Switch, SwitchProps } from '@mui/material'
import { styled } from '@mui/material/styles'

interface SwitchStyledProps extends SwitchProps {
  disabledVariant?: 'inactive' | 'loading'
}

const SwitchStyled = styled(Switch, {
  shouldForwardProp: prop => prop !== 'disabledVariant',
})<SwitchStyledProps>(({ theme, disabledVariant }) => ({
  width: 52,
  height: 26,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  overflow: 'visible',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 4,
    transitionDuration: '300ms',
    color: '#fff',
    '&.Mui-checked': {
      transform: 'translateX(26px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        background: 'linear-gradient(135deg, #6E8EFB 0%, #a777e3 100%)',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#6E8EFB',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: disabledVariant === 'inactive' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.8)',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: disabledVariant === 'inactive' ? 0.15 : 0.5,
      ...(disabledVariant !== 'inactive' && {
        '&:after': {
          content: '""',
          position: 'absolute',
          width: 14,
          height: 14,
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105 105" fill="%23e9408f"><circle cx="12.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="0s" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="12.5" cy="52.5" r="12.5" fill-opacity=".5"><animate attributeName="fill-opacity" begin="100ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="52.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="300ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="52.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="600ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="92.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="800ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="92.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="400ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="12.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="700ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="52.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="500ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle><circle cx="92.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="200ms" calcMode="linear" dur="1s" repeatCount="indefinite" values="1;.2;1"/></circle></svg>')`,
          left: 'calc(50% - 7px)',
          top: 'calc(50% - 7px)',
        },
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18,
    backgroundColor: 'currentColor',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
    backdropFilter: 'blur(4px)',
    border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid rgba(0, 0, 0, 0.1)',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'background'], {
      duration: 500,
    }),
  },
}))

SwitchStyled.defaultProps = {
  focusVisibleClassName: '.Mui-focusVisible',
  disableRipple: true,
}

export default SwitchStyled
